module.exports = {
  created: 'Новый',
  life: 'LIFE',
  updating: 'Обновление',
  done: 'Готов',
  doneQm: 'Завершено',
  archive: 'Архив',
  pause: 'Пауза',
  deleting: 'Удаление',
  filling: 'Наполнение',
  active: 'Активен',
  activeQm: 'В работе',
  stopping: 'Остановка',
  starting: 'Запуск',
  actualization: 'Актуализирован',
  removing: 'Удаляется',
  disabled: 'не активно',
  onactive: 'активно',
  new: 'Новый',
  disbanded: 'Расформирован',
  prepare: 'Подготовка',
  createdQm: 'Создана',
  accepted: 'Принята',
  closed: 'Закрыта',
  declined: 'Отклонена',
  in_work: 'На рассмотрении',
  sent: 'Отправлена'
};
